import React from 'react';
import './Manufacturing.css';
import machineImg from '../../../imgs/manufactu.webp'; 

const Manufacturing = () => {
  return (
    <div className="manufactu-container">
      <div className="manufactu-img">
        <img src={machineImg} alt="Manufacturing Machine" className="manufactu1" />
      </div>

      <div className="manufactu-text">
        <h2>Manufacturing Machine</h2>
        <h3>KF380-S8</h3>
        <ul>
          <li> Daily Yield – ≈57600pcs</li>
          <li>Cycle Time – 6 second</li>
          <li> Clamping Force – 380ton</li>
          <li>Processing Temperature – 320~330℃</li>
          <li> Power Consumption – 28kW/h</li>
        </ul>
        <p>
          KF Series Thin Wall Injection Molding Machine is specialized for thin-wall
          products like: food container, plastic cup, cap and so on.
        </p>
        <button className="learn-btn">Learn More</button>
      </div>
    </div>
  );
};

export default Manufacturing;
